import apiSlice from "./apiSlice";
const keyChangeSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addKeyChange: builder.mutation({
      query: (body) => ({
        url: `change`,
        method: "POST",
        body,
      }),
    }),
    editKeyChange: builder.mutation({
      query: ({ id, body }) => ({
        url: `/change/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteKeyChange: builder.mutation({
      query: (id, body) => ({
        url: `change/${id}`,
        method: "DELETE",
        body,
      }),
    }),
    approveKeyChange: builder.mutation({
      query: ({ id }) => ({
        url: `/change/${id}/approve`,
        method: "POST",
      }),
    }),
    rejectKeyChange: builder.mutation({
      query: ({ id, body }) => ({
        url: `/change/${id}/reject`,
        method: "POST",
        body,
      }),
    }),
    updateWorkflowChangeTracker: builder.mutation({
      query: (body) => ({
        url: `/Change/UpdateWorkFlow`,
        method: "POST",
        body,
      }),
    }),
    getChangeOrder: builder.query({
      query: (req) => ({
        url: `Change/${req}`,
      }),
    }),
  }),
});

export const {
  useAddKeyChangeMutation,
  useEditKeyChangeMutation,
  useDeleteKeyChangeMutation,
  useApproveKeyChangeMutation,
  useRejectKeyChangeMutation,
  useUpdateWorkflowChangeTrackerMutation,
  useGetChangeOrderQuery
} = keyChangeSlice;
